import type { ReactNode } from 'react';

import { ReactComponent as LogoCollapsed } from './assets/logo-collapsed.svg';
import { ReactComponent as LogoDashboardDev } from './assets/logo-dashboard-dev.svg';
import { ReactComponent as LogoDashboardUat } from './assets/logo-dashboard-uat.svg';
import { ReactComponent as LogoDashboard } from './assets/logo-dashboard.svg';

/** Selects the dashboard logo by hostname/environment. */
export function getDesktopLogo(): ReactNode {
  const fullUrl = window.location.href;
  if (fullUrl.includes('dev')) return <LogoDashboardDev />;
  if (fullUrl.includes('uat')) return <LogoDashboardUat />;
  return <LogoDashboard />;
}

export function getCollapsedLogo(): ReactNode {
  return <LogoCollapsed />;
}
